import { render, staticRenderFns } from "./viewfull.vue?vue&type=template&id=10e8e4e9&scoped=true&"
import script from "./viewfull.vue?vue&type=script&lang=js&"
export * from "./viewfull.vue?vue&type=script&lang=js&"
import style0 from "./viewfull.vue?vue&type=style&index=0&id=10e8e4e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e8e4e9",
  null
  
)

export default component.exports